import { render, staticRenderFns } from "./ContestJudgeOrderComponent.vue?vue&type=template&id=5f925c37"
import script from "./ContestJudgeOrderComponent.vue?vue&type=script&lang=js"
export * from "./ContestJudgeOrderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports